import { call, takeEvery, put, select } from 'redux-saga/effects'
import { keyBy } from 'lodash'
import { toast } from 'react-toastify'

import MutationApi from '../remote/mutationApi'
import Remote from '../remote'

import { PRINT_ORDER_REQUESTED, FETCH_PRINTERS_REQUESTED, fetchPrintersSucceeded, fetchPrintersFailed } from '../actions/printer'
import Log from '../utils/Log'
import { getMenuById, makeGetCurrentMenu } from '../selectors/menus'
import { getDeviceSubtype } from '../selectors/config'
import { makeGetOrder, makeGetServiceChargeLegalText } from '../selectors/order'

import createPrinterData from '../utils/printing'
import PeripheralBridge from '../utils/peripheralBridge'
import { getPrinter } from '../selectors/printer'
import { getVenueName } from '../selectors/venue'

export function* printOrder(params = {}) {
  const orderUuid = params?.payload?.orderUuid
  const printType = params?.payload?.printType
  const printerUuids = params?.payload?.printerUuids
  const paymentUuid = params?.payload?.paymentUuid

  if (!orderUuid || !printType || !printerUuids) {
    toast.error('Required: printType and printer Uuid information needed')
    return
  }

  if (printerUuids?.length === 1 && printerUuids.includes('local')) {
    const getOrder = makeGetOrder()
    const getServiceChargeLegalText = makeGetServiceChargeLegalText()

    const order = yield select((state) => getOrder(state, orderUuid))
    const menu = yield select((state) => getMenuById(state, order.standMenuUuid))
    const serviceChargeLegal = yield select((state) => getServiceChargeLegalText(state, orderUuid))
    const deviceSubtype = yield select(getDeviceSubtype)
    const localPrinter = yield select((state) => getPrinter(state, 'local'))
    const venueName = yield select(getVenueName)

    const printingData = createPrinterData({ deviceSubtype, menu, order, serviceChargeLegal, venueName, printType })
    const bridgeInstance = PeripheralBridge.getBridge()

    if (!bridgeInstance) {
      toast.error('Print Failed: Communication could not be established')
      return
    }

    if (localPrinter?.state !== 'connected') {
      toast.error(`Print Failed: ${localPrinter?.name ?? 'Local Printer'} is not connected`)
      return
    }

    bridgeInstance.callHandler('printReceipt', printingData, (data) => {
      // Should we do something here?
    })

    if (printType === 'suite-receipt-auth') {
      bridgeInstance.callHandler('printReceipt', printingData, (data) => {
        // Should we do something here?
      })
    }
  } else {
    let payload = {
      orderUuid,
      printType,
      printerUuids,
      paymentUuid,
    }

    try {
      yield call(MutationApi.printOrder, payload)
    } catch (err) {
      const errorMessage = err?.response?.data?.errorMessage ?? "Sorry, but something went wrong"
      handleError(errorMessage, orderUuid, err)
    }
  }
}

export function* fetchPrinters(params = {}) {
  const venueUuid = process.env.REACT_APP_VENUE_UUID

  try {
    const result = yield call(Remote.getPrinters, venueUuid)
    const byId = keyBy(result?.data?.printers, 'uuid')
    yield put(fetchPrintersSucceeded({ byId }))
  } catch (err) {
    Log.error('Fetch printers failed')
    yield put(fetchPrintersFailed(err))
  }
}

export function* watchPrintOrder() {
  yield takeEvery(PRINT_ORDER_REQUESTED, printOrder)
}


export function* watchFetchPrinters() {
  yield takeEvery(FETCH_PRINTERS_REQUESTED, fetchPrinters)
}

const handleError = (errorMessage, orderUuid, errObject = {}) => {
  Log.error('Print order failed', {
    orderUuid,
  })
}
